import type {
  CarsCompletedEffortCounts,
  CarsThroughputPeriodGroupBy,
} from "../types";
import {
  addDaysToYmd,
  formatDateForDisplay,
  formatDateShort,
  formatMonthYearLong,
  getBrazilCalendarMonthBounds,
} from "./dateUtils";

export const EFFORT_ORDER: Array<{
  key: keyof CarsCompletedEffortCounts;
  label: string;
  bar: string;
  text: string;
}> = [
  { key: "leve", label: "Leve", bar: "border-l-emerald-500 dark:!border-l-emerald-400", text: "text-emerald-800 dark:text-emerald-300" },
  { key: "medio", label: "Médio", bar: "border-l-amber-400 dark:!border-l-amber-400", text: "text-amber-900 dark:text-amber-300" },
  { key: "pesado", label: "Pesado", bar: "border-l-red-500 dark:!border-l-rose-400", text: "text-red-900 dark:text-rose-300" },
];

export function getPeriodRequestBounds(
  groupBy: CarsThroughputPeriodGroupBy,
  period: string,
): { startDate: string; endDate: string } {
  if (groupBy === "day") {
    return { startDate: period, endDate: period };
  }

  if (groupBy === "week") {
    return { startDate: period, endDate: addDaysToYmd(period, 6) };
  }

  const [year, month] = period.split("-").map((part) => parseInt(part, 10));
  return getBrazilCalendarMonthBounds(year, month);
}

export function formatThroughputPeriodLabel(
  period: string,
  groupBy: CarsThroughputPeriodGroupBy,
): string {
  if (groupBy === "month") {
    const [year, month] = period.split("-");
    if (year && month) {
      return formatMonthYearLong(parseInt(month, 10), parseInt(year, 10));
    }
    return period;
  }

  if (groupBy === "week") {
    const weekEnd = addDaysToYmd(period, 6);
    return `${formatDateShort(period)} — ${formatDateShort(weekEnd)}`;
  }

  return formatDateForDisplay(period);
}

export function formatMinutesDuration(min: number): string {
  if (!Number.isFinite(min) || min <= 0) return "0 min";

  const totalMinutes = Math.round(min);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}min`;
  if (hours > 0) return `${hours}h`;
  return `${minutes} min`;
}
